module.exports = __webpack_public_path__ + "img/Concrete.38b6f818.jpg";